// extracted by mini-css-extract-plugin
export default {"p_content":"_3a0909b6fc"};